<template>
  <div class="container-fluid p-0" style="margin-top:48px">
    <nav class="navbar navbar-dark fixed-top justify-content-between">
      <div class="d-flex">
        <router-link class="navbar-brand m-0" :to="{ name:'home' }">LiveABC</router-link>
        <ul class="d-flex my-auto" style="color:white;list-style:none;">
          <li class="mx-2 nav-btn" @click="goMenu">{{$t('exam_list')}}</li>
          <li class="mx-2 nav-btn active" @click="goMenu">{{$t('720_editor')}}</li>
          <li class="mx-2 nav-btn" @click="goMenu">{{$t('logout')}}</li>
        </ul>
      </div>
      <a class="navbar-brand rwd-hide m-0" href="#">{{$t('welcome')}} {{username}}</a>
    </nav>
    <div style="height:92vh;overflow: hidden">
      <iframe  class="mt-1" frameborder="0"  scrolling="auto" style="width:100%; height:100%;" :src="`https://vreditor.istaging.com/buildings/${$route.params.id}/basic-info?enterprise=610687ab179232f02dfacd4c0986648f47a081c4`"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VrEditor',
  components: {
  },
  data () {
    return {
      username: ''
    }
  },
  mounted () {
    const vm = this
    if (window.localStorage.getItem('login')) {
      this.username = JSON.parse(window.localStorage.getItem('login')).username
    } else {
      vm.$router.replace({
        name: 'login'
      })
    }
  },
  destroyed () {
    this.bus.$emit('prevous', this.$t('720_editor'))
  },
  methods: {
    goMenu (e) {
      this.currentMenu = e.target.textContent
      switch (e.target.textContent) {
        case this.$t('exam_list'):
          this.$router.push({ name: 'exam.editor' })
          break
        case this.$t('720_editor'):
          this.$router.push({ name: 'exam.editor' })
          break
        default:
          localStorage.removeItem('login')
          this.$router.push({ name: 'login' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .navbar {
    background-color: #000;
    box-shadow: 0 0 15px #2e2e2e;
  }
  li {
    text-align: left;
  }
  .nav-body {
    padding: 10%;
  }
  .nav-btn {
    cursor: pointer;
    color: #fff;
    list-style:none;
  }

  .active {
    // text-shadow: 0.2em 0.2em 0.5em black;
    text-shadow: 0 0 0.2em rgb(182, 182, 182), 0 0 0.2em rgb(182, 182, 182),
      0 0 0.2em rgb(182, 182, 182)
  }
</style>
